import deepmerge from 'deepmerge';
import {SchemeLink} from '../../../applink/SchemeLink';
import {twMerge} from '../../../common/twMerge';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {LineBanner} from '../LineBanner/LineBanner';
import {ContentHomeNoticeLineBannersProps} from './ContentHomeNoticeLineBannersProps.interface';

export function ContentHomeNoticeLineBanners({
  isMobile,
  lineBannerList = [],
}: ContentHomeNoticeLineBannersProps) {
  if (lineBannerList.length === 0) {
    return null;
  }

  return (
    <>
      <div
        className={twMerge(
          'mb-8pxr flex flex-col justify-center space-y-8pxr px-11pxr',
          !isMobile && 'bg-theme-bg-surface-alt'
        )}
        {...putTiaraObjectProps({
          click: {layer1: '관련이벤트'},
        })}
      >
        {lineBannerList.map(
          (
            {id, scheme, title, subTitle, bgColor, rightImage, eventLog},
            index
          ) => {
            const noticeLineBannerLogObj = {
              click: {ordnum: String(index + 1)},
              eventMeta: {
                id: scheme,
                type: 'scheme',
                name: title,
              },
            };

            return (
              <SchemeLink scheme={scheme} key={id}>
                <LineBanner
                  {...putTiaraObjectProps(
                    eventLog
                      ? deepmerge(eventLog, noticeLineBannerLogObj)
                      : noticeLineBannerLogObj
                  )}
                  bannerTitle={title}
                  subTitle={subTitle}
                  bgColor={bgColor}
                  rightImage={rightImage}
                  onClick={e => LOG_CLICK_EVENT('관련이벤트_클릭', e)}
                />
              </SchemeLink>
            );
          }
        )}
      </div>
    </>
  );
}
